import { queryClient } from '../queryClient'
import { asyncPersister } from './persister'

const LAST_USER_KEY = 'eclipse_last_user'

export async function resetCachedQueriesIfUserChanged(email: string): Promise<void> {
  const user = email.trim().toLowerCase()
  const previousUser = localStorage.getItem(LAST_USER_KEY)

  localStorage.setItem(LAST_USER_KEY, user)

  if (previousUser === null || previousUser === user) return

  queryClient.clear()
  await asyncPersister.removeClient()
}
